const COUNTRY_CODES = {
  Australia: "AU",
  Austria: "AT",
  Belgium: "BE",
  Canada: "CA",
  China: "CN",
  Cyprus: "CY",
  Ecuador: "EC",
  "El Salvador": "SV",
  Estonia: "EE",
  "Euro Area": "EU",
  Eurozone: "EU",
  "European Union": "EU",
  Finland: "FI",
  France: "FR",
  Germany: "DE",
  Greece: "GR",
  Ireland: "IE",
  Italy: "IT",
  Japan: "JP",
  Kosovo: "XK",
  Latvia: "LV",
  Lithuania: "LT",
  Luxembourg: "LU",
  Malta: "MT",
  Montenegro: "ME",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Portugal: "PT",
  Slovakia: "SK",
  Slovenia: "SI",
  Spain: "ES",
  Switzerland: "CH",
  "United Kingdom": "GB",
  "United States": "US",
};

const CURRENCY_COUNTRY_CODES = {
  AUD: "AU",
  CAD: "CA",
  CHF: "CH",
  CNY: "CN",
  EUR: "EU",
  GBP: "GB",
  JPY: "JP",
  NZD: "NZ",
  USD: "US",
};

export const parseCalendarDate = (value) => {
  const match = String(value || "").match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/
  );
  if (!match) return new Date(value);

  return new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
    Number(match[4]),
    Number(match[5]),
    Number(match[6])
  );
};

export const isCalendarEventPast = (value, now = new Date()) => {
  const date = parseCalendarDate(value);
  return !Number.isNaN(date.getTime()) && date.getTime() < now.getTime();
};

export const getCountryCode = (country, currency) =>
  COUNTRY_CODES[country] || CURRENCY_COUNTRY_CODES[currency] || null;

export const getCountryFlag = (country, currency) => {
  const countryCode = getCountryCode(country, currency);
  if (!countryCode) return "🌐";

  return countryCode
    .toUpperCase()
    .split("")
    .map((character) => String.fromCodePoint(127397 + character.charCodeAt(0)))
    .join("");
};
